import React, { useState } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';

function SearchForm({ onSearch }) {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // 親コンポーネントの検索関数を呼び出す
    if (searchTerm.trim()) {
      onSearch(searchTerm);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group>
        <InputGroup className="search-form">
          <Form.Control
            type="text"
            placeholder="選手番号を入力（例: 3978）"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
            aria-label="選手番号"
          />
          <Button 
            type="submit" 
            variant="primary"
            disabled={!searchTerm.trim()}
          >
            検索
          </Button>
        </InputGroup>
      </Form.Group>
    </Form>
  );
}

export default SearchForm;